import { isPortrait } from '@src/js/common/utils';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { softKeyboardHeightManager } from '../utils/soft-keyboard-height-manager';

export enum EditPanelType {
    TEXT_EDIT = 'textEdit',
    ADD_ADIT = 'addEdit',
    COLOR_PANEL = 'addEdit',
    LAYOUT_SUGGESTION = 'layoutSuggestion',
    AI_REPLACE_SLIDE = 'ai_replace_slide',
    NONE = 'none',
}

export enum ColorPanelType {
    NONE = 'none',
    FONT = 'font',
    FILL = 'fill',
    BORDER = 'border',
}

export const MOBILE_EDIT_PANEL_HEIGHT = 290;
export const HORIZONTAL_MOBILE_EDIT_PANEL_HEIGHT = 190;
export const isMobileAndHorizontal = (): boolean => browser.isMobile && !browser.isPad && !isPortrait();

// 获取文字编辑面板高度
export function getMobileEditPanelHeight(): number {
    if (isMobileAndHorizontal()) {
        return HORIZONTAL_MOBILE_EDIT_PANEL_HEIGHT;
    }
    // 竖屏时尽可能保证文字编辑面板和键盘齐平
    const softKeyboardHeight = softKeyboardHeightManager.getHeight();
    return softKeyboardHeight || MOBILE_EDIT_PANEL_HEIGHT;
}
